import * as React from 'react';
import styles from '../../../styles/components/Common/highlight.module.scss';
import {createDataTestId} from '../../../utils/dataTestId';

export const highlightText = (
    title: string,
    searchQuery: string,
    ignorecase: boolean = true,
    searchFromBeginning: boolean = false,
    withDataTestId: boolean = true
) => {
    if (!searchQuery || !title) {
        return title;
    }

    if (typeof searchQuery !== 'string') {
        return null;
    }

    const search = searchQuery.trim();
    const regEx = getRegex(search, ignorecase, searchFromBeginning);
    const parts = title.split(regEx).filter(str => str !== '');
    const dataTestId = withDataTestId ? createDataTestId('highlighted-text') : {};

    return (
        <span>
            {parts.map((part, i) => {
                if ((i > 0 && searchFromBeginning) || !isHighlightNeeded(part, search, regEx))
                    return part;
                return (
                    <span key={i} className={styles.componenet} {...dataTestId}>
                        {part}
                    </span>
                );
            })}
        </span>
    );
};

const isHighlightNeeded = (part: string, search: string, regex: string | RegExp) => {
    if (search.includes('?') || search.includes('*')) {
        return part && part.match(regex) && part.match(regex).length > 0;
    } else return part.toLowerCase() === search.toLowerCase();
};

const getRegex = (search, ignorecase, searchFromBeginning) => {
    const escReg = escapeRegExp(search);
    const afterReplaceJokers = replaceJokers(escReg);
    return new RegExp(
        `${searchFromBeginning ? '^' : ''}(${afterReplaceJokers})`,
        `${ignorecase ? 'i' : ''}`
    );
};

const replaceJokers = (text: string) => {
    let str = text.replace(/\?/g, '.');

    //search 2 words in string exp: query = a*b  should highlight a or b in the string
    str = str.replace(/\*/g, '.*');
    return str;
};

const escapeRegExp = (text: string) => {
    return text.replace(/[-[\]{}()+./,\\^$|#]/g, '\\$&');
};
